export default {"src":"/_next/static/media/option2Tab.7e66fe17.svg","height":231,"width":368,"blurWidth":0,"blurHeight":0};